import React from "react";
import usePosts from "../../hooks/usePosts";
import PostCard from "../../Shared/PostCard/PostCard";
import { useNavigate } from "react-router-dom";

const Feeds = () => {
  const { isLoading, data } = usePosts();
  const navigate = useNavigate();

  // console.log(isLoading);
  // if (isLoading) {
  //   return (

  //   );
  // }

  // console.log(data);

  return (
    <div>
      <div className="py-[3px]">
        <div className="rounded-t-[20px] w-full bg-rose-500 text-primary-content">
          <div className="card-body py-2 items-center text-center">
            <img className="w-[30px]" src="/culogo.png" alt="" srcset="" />
            <h2 className="card-title text-white">cuFeeds</h2>
          </div>
        </div>
      </div>

      {!navigator.onLine ? (
        <div className="text-center py-[150px]">
          <p>No internet. Please check your internet connection.</p>
        </div>
      ) : isLoading ? (
        <div className="grid justify-items-center w-full py-[150px]">
          <div className="flex flex-col gap-4 px-4 w-52">
            <div className="skeleton h-32 w-full"></div>
            <div className="skeleton h-4 w-28"></div>
            <div className="skeleton h-4 w-full"></div>
            <div className="skeleton h-4 w-full"></div>
          </div>
        </div>
      ) : !data?.length ? (
        <div className="text-center py-[160px]">
          <p>Sorry!!! No data found now.</p>
          <p>Happy to see you next time.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mx-2">
          {data?.map((post, index) => {
            // console.log(post);
            return (
              <PostCard navigate={navigate} post={post} key={index}></PostCard>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Feeds;
